(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Career-openings"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionContainer = document.querySelector('[data-accordion-container]');
  
  if (!accordionContainer) return;
  
  const triggers = accordionContainer.querySelectorAll('[data-accordion-trigger]');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const currentItem = this.closest('.accordion-item');
      const isActive = currentItem.classList.contains('active');
      
      // Close all accordion items
      triggers.forEach(t => {
        t.closest('.accordion-item').classList.remove('active');
      });
      
      // If the clicked item wasn't active, open it
      if (!isActive) {
        currentItem.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
